<template>
  <div class="home">
    <div class="text">
      <p>{{$t('home1')}}</p>
      <p>{{$t('home2')}}</p>
      <div class="langButton">
        <questionnaire-button @click.native="changeLang('es')">Español</questionnaire-button>
        <questionnaire-button @click.native="changeLang('ca')">Catalán</questionnaire-button>
      </div>
    </div>
    <div class="end">
      <router-link to="/cuestionario"><questionnaire-button>{{$t('continuar')}}</questionnaire-button></router-link>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeLang(newLang) {
      this.$i18n.locale = newLang
    }
  }
}
</script>

<style scoped lang="scss">
  .home {
      text-align: center;
  }
  .end {
    margin: 3em 0;
  }
  .langButton {
    margin-top: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue